import { render } from "./VaBeneCustomerListPage.vue?vue&type=template&id=4109f51e&ts=true"
import script from "./VaBeneCustomerListPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneCustomerListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__